import React from "react";
import "./Title.scss";
const Title = (props) => {
  const { heading } = props;
  return (
    <div data-aos="fade-right" className="title">
      <h1>{heading}</h1>
      <div></div>
    </div>
  );
};

export default Title;
